import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticateService } from './services/authenticate.service';

// export const authGuard: CanActivateFn = async (childRoute, state) => {
export const authGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const authService = inject(AuthenticateService);

  let authOk = true;

  try {
    await authService.checkAuth();
  } catch (err) {
    console.log('ERR : ', err);
    authOk = false;
  }

  if (authOk) {
    return true;
  } else {
    return router.createUrlTree(['login']);
  }
};
